import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { resetParams } from 'dpl/actions/query_params';
import {
  FILTER_PARAMS,
  RESULTS_TYPES
} from 'dpl/puppy_search_results/utils/constants';
import { PAGE, RESULTS_TYPE } from 'dpl/constants/query_params';
import MobileMenu from 'dpl/components/MobileMenu';
import Icon from 'dpl/common/components/Icon';
import Button from 'dpl/common/design_system/Button';

import SearchFilters from './SearchFilters';

const IS_BOT_UA = window.__DPL_BOT_UA;

export default function MobileFilterMenu({
  isMenuOpen,
  setIsMenuOpen,
  totalItemCount
}) {
  const dispatch = useDispatch();
  const queryParams = useSelector(state => state.queryParams);
  const hasFilters = Object.keys(queryParams).some(qp =>
    FILTER_PARAMS.includes(qp)
  );

  const initialResultType = IS_BOT_UA
    ? RESULTS_TYPES.BREEDERS
    : RESULTS_TYPES.PUPPIES;
  const resultsType = queryParams[RESULTS_TYPE] || initialResultType;

  function clearFilters() {
    dispatch(resetParams(PAGE, ...FILTER_PARAMS, { hash: true }));
  }

  const puppyTitle = totalItemCount === 1 ? 'puppy' : 'puppies';
  const breederTitle = totalItemCount === 1 ? 'breeder' : 'breeders';

  const itemType =
    resultsType === RESULTS_TYPES.PUPPIES ? puppyTitle : breederTitle;

  return (
    <>
      <div
        className={classnames(
          'scrim--black fixed z-max left-0 top-0 right-0 bottom-0 transition pointer-events-none',
          {
            'o-0': !isMenuOpen,
            'o-100': isMenuOpen
          }
        )}
      />
      <MobileMenu
        className="pv4 no-scrollbars"
        position="bottom"
        isOpen={isMenuOpen}
        footer={
          <div className="ph4 pv6 ph12-sm flex justify-between">
            <button
              type="button"
              className={classnames('ph6 ph8-sm pv2 font-16 fw-medium mr2', {
                midnight: hasFilters,
                disabled: !hasFilters
              })}
              onClick={clearFilters}
              disabled={!hasFilters}
            >
              Clear filters
            </button>
            <Button
              type="button"
              variant="primary"
              size="small"
              className="font-16"
              onClick={() => setIsMenuOpen(false)}
            >
              Show {totalItemCount} {itemType}
            </Button>
          </div>
        }
      >
        <div className="MobileFilterMenu flex flex-column bg-white min-h-100 overflow-y-auto">
          <div className="bb br--top b--light-gray flex items-center br3 justify-between fw-medium pt6 pb4 ph4 mb8">
            <p className="font-30 font-serif">
              Filter Results ({totalItemCount})
            </p>
            <button
              type="button"
              onClick={() => setIsMenuOpen(false)}
              data-test-id="mobileFiltersToggleOff"
              className="ba br-100 b--default dib pv2 ph2"
            >
              <Icon name="fetch-close" width="16px" height="16px" />
            </button>
          </div>
          <SearchFilters />
        </div>
      </MobileMenu>
    </>
  );
}

MobileFilterMenu.propTypes = {
  isMenuOpen: PropTypes.bool,
  setIsMenuOpen: PropTypes.func.isRequired,
  totalItemCount: PropTypes.number.isRequired
};

MobileFilterMenu.defaultProps = {
  isMenuOpen: false
};
